
import 'fetch-polyfill';

import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from '../async/asyncActions';

import { DELETE_OTP, GENERATE_OTP, VERIFY_OTP } from './OTPconstants';

import { closeModal } from '../modals/modalActions';

import {
  toastr
} from 'react-redux-toastr';

export const generateOTP = (generateOTPAPI, payload, csrfRequestIdentifier = '', globalLoader = false) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart("", globalLoader, 'generateOTP'));
      const reqObject = {
        method: generateOTPAPI.method,
        body: JSON.stringify(payload),
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
        }),
      };

      const OTP = await fetch(generateOTPAPI.url, reqObject).then(response=>response.json());

      dispatch({
        type: GENERATE_OTP,
        payload: OTP,
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      toastr.error('OTP Service', `Error while generating OTP, Internal Server Error!`);
      console.log(error);
      dispatch(asyncActionError());
    }
  };
}

export const deleteOTP = () => {
  return {
    type: DELETE_OTP,
    payload: {}
  }
}

export const verifyOTP = (verifyOTPAPI,  data, payload, forwardAction, csrfRequestIdentifier, token) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart("", false, 'verifyOTP'));
      const header = {
        'userAgent': navigator.userAgent,
        'Content-type': 'application/json',
        csrfRequestIdentifier,
        userMachineIdentifier: 'Linux',
        ipAddress: 'ipAddress',
        host: 'HOST_'
      };

      // Explicit token
      if (payload.token) {
        header['token'] = payload.token;
      }

      const reqObject = {
        method: verifyOTPAPI.method,
        body: JSON.stringify(data),
        headers: new Headers(header),
      };

      const verify = await fetch(verifyOTPAPI.url, reqObject).then(response=>response.json());


      if ((verify.data && verify.data.otpVerified) || verify.transactionId){
        dispatch(closeModal());

        if(typeof forwardAction === 'function') {
          forwardAction(verify.data, payload, csrfRequestIdentifier, token);
        }
      }

      dispatch({
        type: VERIFY_OTP,
        payload: verify,
      });
      dispatch(asyncActionFinish());
      return verify;
    } catch (error) {
      toastr.error('OTP Service', `Error while verifying OTP, Internal Server Error!`);
      console.log(error);
      dispatch(asyncActionError());
    }
  };
};